import { ChevronLeft, ChevronRight } from 'lucide-react'
import * as React from 'react'
import { DayPicker, DayPickerProps } from 'react-day-picker'

import { clx } from '@/utils/clx'

export type CalendarProps = DayPickerProps

export const Calendar = ({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) => {
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			className={clx('p-3', className)}
			classNames={{
				root: '',
				months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
				month: 'space-y-4',
				month_caption: 'flex justify-center pt-1 relative items-center',
				caption_label: 'text-sm font-medium',
				nav: 'space-x-1 flex items-center',
				button_previous: clx(
					'absolute left-1',
					'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
					'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors',
					'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
					'disabled:pointer-events-none disabled:opacity-50'
				),
				button_next: clx(
					'absolute right-1',
					'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
					'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors',
					'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
					'disabled:pointer-events-none disabled:opacity-50'
				),
				month_grid: 'w-full border-collapse space-y-1',
				weekdays: 'flex',
				weekday: 'text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]',
				week: 'flex w-full mt-2',
				day: clx('relative p-0 text-center text-sm focus-within:relative focus-within:z-20', 'h-8 w-8'),
				day_button: clx(
					'h-8 w-8 p-0 font-normal',
					'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors',
					'hover:bg-accent hover:text-accent-foreground',
					'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
					'disabled:pointer-events-none disabled:opacity-50'
				),
				selected: 'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground',
				today: 'bg-accent text-accent-foreground',
				outside: 'text-muted-foreground opacity-50',
				disabled: 'text-muted-foreground opacity-50',
				hidden: 'invisible',
				...classNames
			}}
			components={{
				Chevron: ({ orientation }) =>
					orientation === 'left' ? <ChevronLeft className='h-4 w-4' /> : <ChevronRight className='h-4 w-4' />
			}}
			{...props}
		/>
	)
}

Calendar.displayName = 'Calendar'
